import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AdministrationSummaryService } from '../../../services/administration/administration-summary.service';
import { APPLICATION_TYPE_BUDGET } from '../../../models/common';
import { DatePipe } from '@angular/common';
import { CommonService } from '../../../services/common.service';
import * as $ from 'jquery';
@Component({
    selector: 'app-new-budget-view-modal',
    templateUrl: './new-budget-view-modal.component.html',
    styleUrl: './new-budget-view-modal.component.scss'
})
export class NewBudgetViewModalComponent implements OnInit {
    @Input() Content: any;
    BudgetassignmentForm: FormGroup;
    AppTypeChildBudgetsList: APPLICATION_TYPE_BUDGET[] = [];
    ModulesListDropDown: any[] = [];
    SubModulesListDropDown: any[] = [];
    FiscalTimelinesDropDown: any[] = [];
    CalendarTimelinesDropDown: any[] = [];
    TargetTimelinesDropDown: any[] = [];
    ApplicationTypesDropDown: any[] = [];
    grantsAppTypesDropDown: any[] = [];
    allAppData: any[] = [];
    SUM_ALLOCATED: number = null;
    SUM_CONSUMED: number = null;
    SUM_REMAINING: number = null;
    SUM_ACTUAL_AVAILABLE: number = null;
    OLD_SUM_ACTUAL_AVAILABLE: number = null;
    BudgetTimeLineTypesDropDown = [
        { label: "Select", value: 0 },
        { label: "Fiscal Year", value: 1 },
        { label: "Calendar Year", value: 2 },
        { label: "Custom Date", value: 3 },
    ];
    EffectiveBudgetListDropDown = [
        { label: "Inactive", value: 1 },
        { label: "Active", value: 2 },
        { label: "On-hold", value: 3 },
        { label: "Closed", value: 4 },
    ];

    IsCustomType: boolean = false;
    IsYearType: boolean = false;
    currencySymbol: string = "$";
    currencySymbolsList: any[] = []
    constructor(
        public modalRef: NgbActiveModal,
        private fb: FormBuilder,
        private summarService: AdministrationSummaryService,
        private datePipe: DatePipe,
        private commonService: CommonService,
        private summaryService: AdministrationSummaryService
    ) {
        this.modalRef.close();
    }

    ngOnInit() {
        this.BudgetassignmentForm = this.fb.group({
            ID: [],
            MODULE_ID: ["", [Validators.required]],
            PROGRAM_CODE: ["", [Validators.required]],
            TIMELINE_TYPE: [0],
            TIMELINE_VALUE: [''],
            BUDGET_STATUS: [1],
            ALLOCATED_AMOUNT: [null, [Validators.required]],
            OLD_ALLOCATED_AMOUNT: [null],
            CUSTOM_START_DATE: [null],
            CUSTOM_END_DATE: [null],
            BUDGET_NAME: [{ value: null, disabled: true }],
            StartDate_DATEO: [null],
            EndDate_DATEO: [null],
            ACTUAL_REMAINING_BUDGET: [null],
        });

        this.BudgetassignmentForm.controls["BUDGET_NAME"].disable();
        if (this.Content.heading == "New") {
            this.BudgetassignmentForm.controls["BUDGET_STATUS"].disable();
            this.GetMasterData("-1", "-1");
        }
        else {
            this.BudgetassignmentForm.controls["MODULE_ID"].disable();
            this.BudgetassignmentForm.controls["PROGRAM_CODE"].disable();
            this.BudgetassignmentForm.controls["TIMELINE_TYPE"].disable();
            this.BudgetassignmentForm.controls["TIMELINE_VALUE"].disable();
            this.BudgetassignmentForm.controls["MODULE_ID"].setValue(this.Content.MODULE_ID);
             
            this.ProgramChange({ value: this.Content.MODULE_ID });
            if (this.Content.MODULE_ID == "4") {
              this.BudgetassignmentForm.controls["PROGRAM_CODE"].setValue(this.Content.PROGRAM_CODE);
                this.onGrantTypeChange({ value: this.Content.PROGRAM_CODE });
            }
            if (this.Content.heading == "View") {
                this.BudgetassignmentForm.disable();
            }
            this.GetMasterData(this.Content.ID, this.Content.MODULE_ID);
        }


    }
    AddNewChild() {
        let moduleid = this.BudgetassignmentForm.controls["MODULE_ID"].value;
        let newChild = new APPLICATION_TYPE_BUDGET();
        newChild.ID = (this.AppTypeChildBudgetsList.length + 1) + "";
        newChild.STATUS = "Add";
        newChild.APPLICATION_TYPE_ID = "";
        newChild.ALLOCATED_BUDGET = null;
        newChild.OLD_ALLOCATED_BUDGET = 0;
        newChild.CONSUMED_AMOUNT = null;
        newChild.AppType = this.ApplicationTypesDropDown;
        this.AppTypeChildBudgetsList.push(newChild);
    }
    RemoveChild(newChild) {
        if (newChild.CONSUMED_AMOUNT <= 0) {
            this.AppTypeChildBudgetsList = this.AppTypeChildBudgetsList.filter((item) => {
                return (item.ID != newChild.ID)
            });
            if (this.Content.heading != "New") {
                this.OLD_SUM_ACTUAL_AVAILABLE = this.OLD_SUM_ACTUAL_AVAILABLE + parseFloat(newChild.OLD_ALLOCATED_BUDGET);
            }
            this.caliculateSum();
        }
    }
    ProgramChange($event) {
        let moduleid = this.BudgetassignmentForm.controls["MODULE_ID"].value;
        let submoduleid = this.BudgetassignmentForm.controls["PROGRAM_CODE"].value;
        switch (moduleid) {
            case "2": //IEG
                this.currencySymbol = this.currencySymbolsList.find(c => c.value == "CURRENCY_SYMBOL_IST")?.label;
                break;
            case "4": //Grants Management
                this.currencySymbol = "$";
                break;
            default:
                this.currencySymbol = "$";
                break;
        }
        if (moduleid != "4") {
            this.BudgetassignmentForm.controls["PROGRAM_CODE"].setValue("");
            this.GetProgramApplicationTypes();
        }

        this.YearChange($event);
    }

    GetProgramApplicationTypes() {
        let moduleid = this.BudgetassignmentForm.controls["MODULE_ID"].value;
        let submoduleid = this.BudgetassignmentForm.controls["PROGRAM_CODE"].value == "" ? "-1" : this.BudgetassignmentForm.controls["PROGRAM_CODE"].value;

        this.summarService.GetData("api/BudgetAssignment/ProgramAgainstAppTypes?ModuleID=" + moduleid + "&SubModuleID=" + submoduleid).subscribe({
            next: (result) => {
                if (result.Status == 0) {
                    this.ApplicationTypesDropDown = [{ label: "Select", value: "" }].concat(result.Data["MasterData1"]);
                    this.AppTypeChildBudgetsList = [];
                    this.SUM_ALLOCATED = null;
                    this.SUM_CONSUMED = null;
                    this.SUM_REMAINING = null;
                    this.SUM_ACTUAL_AVAILABLE = this.BudgetassignmentForm.controls["ALLOCATED_AMOUNT"].value;
                    this.OLD_SUM_ACTUAL_AVAILABLE = this.BudgetassignmentForm.controls["ALLOCATED_AMOUNT"].value;
                }
            },
            error: () => {

            },
        });
    }
    onGrantTypeChange($event) {
        switch ($event.value) {
            case "GRANTSCME": //CME
                this.currencySymbol = this.currencySymbolsList.find(c => c.value == "CURRENCY_SYMBOL_CME")?.label;
                break;
            case "GRANTSCHARITABLE": //Charity
                this.currencySymbol = this.currencySymbolsList.find(c => c.value == "CURRENCY_SYMBOL_CHARITABLE")?.label;
                break;
            case "GRANTSSPONSORSHIP": //Sponcer
                this.currencySymbol = this.currencySymbolsList.find(c => c.value == "CURRENCY_SYMBOL_SPONSERSHIP")?.label;
                break;
        }
        this.GetProgramApplicationTypes()

    }

    BudgetTimelineChange($event) {
        let targetvalue = $event.value;
        this.IsCustomType = false;
        this.IsYearType = true;
        if (targetvalue == 1) {
            this.BudgetassignmentForm.controls["TIMELINE_VALUE"].setValue("");
            this.BudgetassignmentForm.controls["CUSTOM_START_DATE"].setValue(null);
            this.BudgetassignmentForm.controls["CUSTOM_END_DATE"].setValue(null);
            this.TargetTimelinesDropDown = this.FiscalTimelinesDropDown;
        }
        else if (targetvalue == 2) {
            this.BudgetassignmentForm.controls["TIMELINE_VALUE"].setValue("");
            this.BudgetassignmentForm.controls["CUSTOM_START_DATE"].setValue(null);
            this.BudgetassignmentForm.controls["CUSTOM_END_DATE"].setValue(null);
            this.TargetTimelinesDropDown = this.CalendarTimelinesDropDown;
        }
        else {
            this.BudgetassignmentForm.controls["TIMELINE_VALUE"].setValue("");
            this.IsCustomType = true;
            this.IsYearType = false;
            this.TargetTimelinesDropDown = [];
        }

    }
    YearChange($event) {
        let type = this.BudgetassignmentForm.controls["TIMELINE_TYPE"].value;
        let moduleid = this.BudgetassignmentForm.controls["MODULE_ID"].value;
        let timeline = this.BudgetassignmentForm.controls["TIMELINE_VALUE"].value;

        let ModuleObj = this.ModulesListDropDown.filter((item) => {
            return (item.value == moduleid)
        })[0];

        let timeObj = this.TargetTimelinesDropDown.filter((item) => {
            return (item.value == timeline)
        })[0];
        if (type == 3) {
            let startDate = this.BudgetassignmentForm.controls["CUSTOM_START_DATE"].value;
            let enddate = this.BudgetassignmentForm.controls["CUSTOM_END_DATE"].value;
            const formDate = this.datePipe.transform(startDate, 'dd-MMM-yyyy') || "";
            const TodDate = this.datePipe.transform(enddate, 'dd-MMM-yyyy') || "";
            if (ModuleObj) {
                let name = ModuleObj.label + " (" + formDate + " - " + TodDate + ")";
                this.BudgetassignmentForm.controls["BUDGET_NAME"].setValue(name);
            }
        }
        else {
            if (ModuleObj && timeObj) {
                let name = ModuleObj.label + " (" + timeObj.label + ")";
                this.BudgetassignmentForm.controls["BUDGET_NAME"].setValue(name);
            }
        }

    }
    GetMasterData(RecordID: string, ModuleID: string) {
        this.summarService.GetData("api/BudgetAssignment/GetMasterData/" + RecordID + "/" + ModuleID).subscribe({
            next: (result) => {
                if (result.Status == 0) {
                    this.ModulesListDropDown = [{ label: "Select", value: "" }].concat(result.Data["MasterData1"]);
                    this.CalendarTimelinesDropDown = [{ label: "Select", value: "" }].concat(result.Data["MasterData2"]);
                    this.FiscalTimelinesDropDown = [{ label: "Select", value: "" }].concat(result.Data["MasterData3"]);
                    this.currencySymbolsList = result.Data["MasterData4"];
                    this.SubModulesListDropDown = [{ label: "Select", value: "" }].concat(result.Data["MasterData5"]);
                }
                if (this.Content.heading != "New") {
                    this.currencySymbol = this.currencySymbolsList.find(c => c.value == "CURRENCY_SYMBOL")?.label;
                    this.GetBudgetEdit();
                    this.BudgetassignmentForm.controls["CUSTOM_START_DATE"].disable();
                    this.BudgetassignmentForm.controls["CUSTOM_END_DATE"].disable();

                }
                else {
                    switch (ModuleID) {
                        case "2":
                            this.currencySymbol = this.currencySymbolsList.find(c => c.value == "CURRENCY_SYMBOL_IST")?.label;
                            break;
                        case "4":
                            this.currencySymbol = "$";
                            break;
                    }
                }
            },
            error: () => {

            },
        })
    }
    GetBudgetEdit() {
        this.summaryService.GetData("api/BudgetAssignment/Fetch?RecordID=" + this.Content.ID).subscribe(summary => {
            if (summary.Status == 0) {
                this.BudgetassignmentForm.patchValue(summary.Data);
                this.SUM_ACTUAL_AVAILABLE = summary.Data.ACTUAL_REMAINING_BUDGET;
                this.OLD_SUM_ACTUAL_AVAILABLE = summary.Data.ACTUAL_REMAINING_BUDGET;
                this.BudgetassignmentForm.controls["CUSTOM_START_DATE"].setValue(new Date((summary.Data.CUSTOM_START_DATE)));
                this.BudgetassignmentForm.controls["CUSTOM_END_DATE"].setValue(new Date((summary.Data.CUSTOM_END_DATE)));
                this.AppTypeChildBudgetsList = summary.Data["AppTypeChildBudgetsList"];
                this.BudgetTimelineChange({ value: summary.Data.TIMELINE_TYPE });
                this.BudgetassignmentForm.controls["TIMELINE_VALUE"].setValue(summary.Data.TIMELINE_VALUE);
                this.caliculateSum();
                this.AppTypeChildBudgetsList.forEach((child) => {
                    child.AppType = this.ApplicationTypesDropDown;
                });

            }
        });
    }
    validations() {
        let isValid = true;
        let message = "";
        const formData = this.BudgetassignmentForm.getRawValue();

        if (formData.MODULE_ID === null || formData.MODULE_ID === "" || formData.MODULE_ID == undefined) {
            $("#MODULE_ID").addClass("ng-touched ng-invalid validate-error");
            $("#MODULE_ID").removeClass("ng-untouched ng-valid");
            message += "Please select Program </br>";
            isValid = false;
        }
        else {
            $("#MODULE_ID").addClass("ng-untouched ng-valid");
            $("#MODULE_ID").removeClass("ng-touched ng-invalid validate-error");
        }
        if (formData.MODULE_ID !== null && formData.MODULE_ID !== "" && formData.MODULE_ID !== undefined && formData.MODULE_ID === "4") {
            if (formData.PROGRAM_CODE === null || formData.PROGRAM_CODE === "" || formData.PROGRAM_CODE == undefined) {
                $("#PROGRAM_CODE").addClass("ng-touched ng-invalid validate-error");
                $("#PROGRAM_CODE").removeClass("ng-untouched ng-valid");
                message += "Please select Grant type </br>";
                isValid = false;
            }
            else {
                $("#PROGRAM_CODE").addClass("ng-untouched ng-valid");
                $("#PROGRAM_CODE").removeClass("ng-touched ng-invalid validate-error");
            }
        }
        let typevailable = false;
        if (formData.TIMELINE_TYPE === null || formData.TIMELINE_TYPE === "" || formData.TIMELINE_TYPE == undefined || formData.TIMELINE_TYPE == 0) {
            $("#TIMELINE_TYPE").addClass("ng-touched ng-invalid validate-error");
            $("#TIMELINE_TYPE").removeClass("ng-untouched ng-valid");
            message += "Please select Budget </br>";
            isValid = false;
        }
        else {
            typevailable = true;
            $("#TIMELINE_TYPE").addClass("ng-untouched ng-valid");
            $("#TIMELINE_TYPE").removeClass("ng-touched ng-invalid validate-error");
        }

        if (formData.TIMELINE_TYPE != 3 && typevailable) {
            if (formData.TIMELINE_VALUE == null || formData.TIMELINE_VALUE == undefined || formData.TIMELINE_VALUE === "") {
                $("#TIMELINE_VALUE").addClass("ng-touched ng-invalid validate-error");
                $("#TIMELINE_VALUE").removeClass("ng-untouched ng-valid");
                message += "Please select Year </br>";
                isValid = false;
            } else {
                $("#TIMELINE_VALUE").addClass("ng-untouched ng-valid");
                $("#TIMELINE_VALUE").removeClass("ng-touched ng-invalid validate-error");
            }
        }
        if (formData.TIMELINE_TYPE == 3 && typevailable) {
            if (formData.CUSTOM_START_DATE == null || formData.CUSTOM_START_DATE == undefined || formData.CUSTOM_START_DATE === "") {
                $("#CUSTOM_START_DATE").addClass("ng-touched ng-invalid validate-error");
                $("#CUSTOM_START_DATE").removeClass("ng-untouched ng-valid");
                message += "Please select Start Date </br>";
                isValid = false;
            }
            else {
                $("#CUSTOM_START_DATE").addClass("ng-untouched ng-valid");
                $("#CUSTOM_START_DATE").removeClass("ng-touched ng-invalid validate-error");
            }
            if (formData.CUSTOM_END_DATE == null || formData.CUSTOM_END_DATE == undefined || formData.CUSTOM_END_DATE === "") {
                $("#CUSTOM_END_DATE").addClass("ng-touched ng-invalid validate-error");
                $("#CUSTOM_END_DATE").removeClass("ng-untouched ng-valid");
                message += "Please select End Date </br>";
                isValid = false;
            }
            else {
                $("#CUSTOM_START_DATE").addClass("ng-untouched ng-valid");
                $("#CUSTOM_START_DATE").removeClass("ng-touched ng-invalid validate-error");
            }
            let fromDate=formData.CUSTOM_START_DATE;
            let toDate=formData.CUSTOM_END_DATE;
            if (fromDate && toDate) {
                let dateError = new Date(fromDate) > new Date(toDate);
                if (dateError) {
                    $("#CUSTOM_END_DATE").addClass("ng-touched ng-invalid validate-error");
                    $("#CUSTOM_END_DATE").removeClass("ng-untouched ng-valid");
                    message += "End Date should be greater than to Start Date </br>";
                    isValid = false;
                }
            }
        }

        if (formData.ALLOCATED_AMOUNT === null || formData.ALLOCATED_AMOUNT === "" || formData.ALLOCATED_AMOUNT == undefined || formData.ALLOCATED_AMOUNT == 0) {
            $("#ALLOCATED_AMOUNT").addClass("ng-touched ng-invalid validate-error");
            $("#ALLOCATED_AMOUNT").removeClass("ng-untouched ng-valid");
            message += "Please enter Allocated Budget  </br>";
            isValid = false;
        }
        else {
            typevailable = true;
            $("#ALLOCATED_AMOUNT").addClass("ng-untouched ng-valid");
            $("#ALLOCATED_AMOUNT").removeClass("ng-touched ng-invalid validate-error");
        }
        let IS_APPLICATION_TYPE_ID = false;
        let IS_ALLOCATED_BUDGET = false;
        let IS_PERCENTAGE = false;
        let IS_Consumed = false;
        this.AppTypeChildBudgetsList.forEach((child) => {
            if (!child.APPLICATION_TYPE_ID && IS_APPLICATION_TYPE_ID == false) {
                message += "Please select Application Type </br>";
                isValid = false;
                IS_APPLICATION_TYPE_ID = true;
            }
            if (!child.ALLOCATED_BUDGET && IS_ALLOCATED_BUDGET == false) {
                message += "Please enter Allocated Budget </br>";
                isValid = false;
                IS_ALLOCATED_BUDGET = true;
            }
            if (!child.PERCENTAGE && IS_PERCENTAGE == false) {
                message += "Please enter Budget(%) </br>";
                isValid = false;
                IS_PERCENTAGE = true;
            }
            if (IS_Consumed == false && (child.ALLOCATED_BUDGET < child.CONSUMED_AMOUNT)) {
                message += "Cannot reduce allocation below consumed amount </br>";
                isValid = false;
                IS_Consumed = true;
            }
            if (child.CONSUMED_AMOUNT === null || child.CONSUMED_AMOUNT === undefined || child.CONSUMED_AMOUNT.toString() === "") {
                child.CONSUMED_AMOUNT = null;
            }
        });
        if (this.SUM_ALLOCATED > formData.ALLOCATED_AMOUNT) {
            message += "Sum Allocated must not be greater than the Allocated Amount </br>";
            isValid = false;
        }
        if (this.SUM_ACTUAL_AVAILABLE < 0) {
            message += "Actual Available Budget must be greater than Zero </br>";
            isValid = false;
        }
        if (!isValid)
            this.commonService.ValidationBanner(message);

        return isValid;
    }
    save() {
        if (this.validations()) {
            const formData = this.BudgetassignmentForm.getRawValue();
            formData.ID = this.Content.ID;
            formData.ACTUAL_REMAINING_BUDGET = this.SUM_ACTUAL_AVAILABLE;
            formData["AppTypeChildBudgetsList"] = this.AppTypeChildBudgetsList;

            if (this.Content.heading == "New") {
                this.summaryService.Insert('api/BudgetAssignment/Insert', formData).subscribe(result => {
                    if (result.Status === 0) {
                        this.commonService.SuccessBanner(result.Message);
                        this.modalRef.close();
                    }
                    else {
                        this.commonService.ValidationBanner(result.Message);
                    }
                })
            }
            else {
                this.summaryService.Insert('api/BudgetAssignment/Update', formData).subscribe(result => {
                    if (result.Status === 0) {
                        this.commonService.SuccessBanner(result.Message);
                        this.modalRef.close();
                    }
                    else {
                        this.commonService.ValidationBanner(result.Message);
                    }
                })
            }
        }
    }

    DateSelect(event, type) {
        let Full_Date = {
            Day: event.getDate(),
            Month: (event.getMonth() + 1),
            Year: event.getFullYear(),
            Hours: 0,
            Minutes: 0,
            Seconds: 0,
            IsEndDate: false,
            HasValue: true,
            IsDateModified: true
        }
        if (type == "start")
            this.BudgetassignmentForm.controls["StartDate_DATEO"].setValue(Full_Date);
        else
            this.BudgetassignmentForm.controls["EndDate_DATEO"].setValue(Full_Date);

        this.YearChange(event)
    }

    ChangeApplicationType(event, citem: any) {
        let applicationTypeID = citem.APPLICATION_TYPE_ID;

        let isValiable = this.AppTypeChildBudgetsList.filter((item) => {
            return (item.APPLICATION_TYPE_ID == applicationTypeID && item.ID != citem.ID)
        })[0];
        if (isValiable) {
            this.AppTypeChildBudgetsList.forEach((item) => {
                setTimeout(() => {
                    if (item.ID == citem.ID) {
                        citem.APPLICATION_TYPE_ID = "";
                    }
                }, 500);
            })
            this.commonService.ValidationBanner("Budget has already been allocated for the selected Application Type. Kindly select another.");

        }

    }

    ParentBudgetChangeEvent() {
        let TotalBudget = this.BudgetassignmentForm.controls["ALLOCATED_AMOUNT"].value;
        if (TotalBudget) {
            let TotalBudgetFloot = parseFloat(TotalBudget);
            this.AppTypeChildBudgetsList.forEach((item: any) => {
                if (item.ALLOCATED_BUDGET) {
                    let allocatedAMout = parseFloat(item.ALLOCATED_BUDGET);
                    let Percentage = ((allocatedAMout / TotalBudgetFloot) * 100);
                    let PercentageFinal = parseFloat(Percentage.toFixed(2));
                    item.PERCENTAGE = PercentageFinal > 100 ? 100 : PercentageFinal;
                }
                if (!item.ALLOCATED_BUDGET && item.PERCENTAGE) {
                    let allocatedPercent = parseFloat(item.PERCENTAGE);
                    let amounr = ((allocatedPercent / 100) * TotalBudgetFloot);
                    item.ALLOCATED_BUDGET = amounr;
                }
            });
        }
        this.caliculateSum();
    }
    RemainingBalace() {
        if (this.Content.heading != "New") {
            let addedValue = 0;
            let removeValue = 0;
            let OLDTotalBudget = this.BudgetassignmentForm.controls["OLD_ALLOCATED_AMOUNT"].value;
            let ChangedTotalBudget = this.BudgetassignmentForm.controls["ALLOCATED_AMOUNT"].value;
            let OLDTotalBudgetFloat = parseFloat(OLDTotalBudget);
            let ChangedTotalBudgetFloat = parseFloat(ChangedTotalBudget);
            if (OLDTotalBudgetFloat < ChangedTotalBudgetFloat) {
                addedValue = (ChangedTotalBudgetFloat - OLDTotalBudgetFloat);
            }
            else if (OLDTotalBudgetFloat > ChangedTotalBudgetFloat) {
                removeValue = (OLDTotalBudgetFloat - ChangedTotalBudgetFloat);
            }

            if (addedValue < removeValue) {
                let FinalRemovedValue = removeValue - addedValue;
                this.SUM_ACTUAL_AVAILABLE = this.OLD_SUM_ACTUAL_AVAILABLE - FinalRemovedValue;
            }
            else if (addedValue > removeValue) {
                let FinalAddedValue = addedValue - removeValue;
                this.SUM_ACTUAL_AVAILABLE = (this.OLD_SUM_ACTUAL_AVAILABLE + FinalAddedValue);
            }
            else {
                this.SUM_ACTUAL_AVAILABLE = this.OLD_SUM_ACTUAL_AVAILABLE;
            }
            addedValue = 0;
            removeValue = 0;
            this.AppTypeChildBudgetsList.forEach((item: any) => {
                let allocatedAMout = 0;
                let OldallocatedAMout = 0;
                if (item.ALLOCATED_BUDGET) {
                    allocatedAMout = parseFloat(item.ALLOCATED_BUDGET);
                } if (item.ALLOCATED_BUDGET) {
                    OldallocatedAMout = parseFloat(item.OLD_ALLOCATED_BUDGET);
                }
                if (OldallocatedAMout < allocatedAMout) {
                    addedValue = addedValue + (allocatedAMout - OldallocatedAMout);
                }
                else if (OldallocatedAMout > allocatedAMout) {
                    removeValue = removeValue + (OldallocatedAMout - allocatedAMout);
                }

            });

            if (addedValue < removeValue) {
                let FinalRemovedValue = removeValue - addedValue;
                this.SUM_ACTUAL_AVAILABLE = this.SUM_ACTUAL_AVAILABLE + FinalRemovedValue;
            }
            else if (addedValue > removeValue) {
                let FinalAddedValue = addedValue - removeValue;
                this.SUM_ACTUAL_AVAILABLE = (this.SUM_ACTUAL_AVAILABLE - FinalAddedValue);
            }
        }

    }

    AppTypeBudgetChange(ID: any) {
        let TotalBudget = this.BudgetassignmentForm.controls["ALLOCATED_AMOUNT"].value;
        if (TotalBudget) {
            let TotalBudgetFloot = parseFloat(TotalBudget);
            this.AppTypeChildBudgetsList.forEach((item: any) => {
                if (item.ID == ID) {
                    if (item.ALLOCATED_BUDGET) {
                        let allocatedAMout = parseFloat(item.ALLOCATED_BUDGET);
                        let Percentage = ((allocatedAMout / TotalBudgetFloot) * 100);
                        let PercentageFinal = parseFloat(Percentage.toFixed(2));
                        item.PERCENTAGE = PercentageFinal > 100 ? 100 : PercentageFinal;

                    }
                }
            });
        }
        this.caliculateSum();

    }
    AppTypePercentChange(ID: any) {
        let TotalBudget = this.BudgetassignmentForm.controls["ALLOCATED_AMOUNT"].value;
        if (TotalBudget) {
            let TotalBudgetFloot = parseFloat(TotalBudget);
            this.AppTypeChildBudgetsList.forEach((item: any) => {
                if (item.ID == ID) {
                    if (item.PERCENTAGE) {
                        let allocatedPercent = parseFloat(item.PERCENTAGE);
                        let amounr = ((allocatedPercent / 100) * TotalBudgetFloot);
                        item.ALLOCATED_BUDGET = amounr;
                    }
                }
            });
        }


        this.caliculateSum();
    }

    caliculateSum() {
        let sum = 0;
        let cnsume = 0;

        this.AppTypeChildBudgetsList.forEach((item: any) => {
            let allocatedAmount = 0;
            let consumedAmount = 0;
            if (item.ALLOCATED_BUDGET) {
                allocatedAmount = parseFloat(item.ALLOCATED_BUDGET);
            }
            if (item.CONSUMED_AMOUNT) {
                consumedAmount = parseFloat(item.CONSUMED_AMOUNT);
            }
            sum = sum + allocatedAmount;
            cnsume = cnsume + consumedAmount;
        });
        this.SUM_ALLOCATED = sum;
        this.SUM_CONSUMED = cnsume;
        this.SUM_REMAINING = (sum - cnsume);
        if (this.Content.heading == "New") {
            let TotalBudget = this.BudgetassignmentForm.controls["ALLOCATED_AMOUNT"].value;
            if (TotalBudget) {
                let TotalBudgetFloot = parseFloat(TotalBudget);
                this.SUM_ACTUAL_AVAILABLE = TotalBudgetFloot - sum;
            }
        }
        this.RemainingBalace();
    }

    preventInvalidInput(event: KeyboardEvent, type: any): void {
        const invalidChars = ['e', 'E', '+', '-'];
        if (invalidChars.includes(event.key)) {
            event.preventDefault();
            return;
        }

        const allowedKeys = [
            'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Home', 'End'
        ];
        if (allowedKeys.includes(event.key)) {
            return; // allow default behavior
        }

        const input = event.target as HTMLInputElement;
        const { value, selectionStart, selectionEnd } = input;

        // Simulate the value if the key is allowed
        const newValue =
            value.substring(0, (selectionStart ? 0 : selectionStart)) +
            event.key +
            value.substring((selectionEnd ? 0 : selectionEnd));

        if (type != "percent") {
            // Allow numbers with optional one dot and up to 2 decimal places
            //Beacuse In Number(38,2) so 36(Values) and 2(decimal values)
            const decimalRegex = /^\d{0,29}(\.\d{0,2})?$/;

            if (!decimalRegex.test(newValue)) {
                event.preventDefault();
            }
        }
        else {
            const decimalRegex = /^\d{0,30}(\.\d{0,2})?$/;
            if (!decimalRegex.test(newValue)) {
                event.preventDefault();
            }

        }


    }
}
